import { render, staticRenderFns } from "./LabeldeurPage.vue?vue&type=template&id=5d4a0d30"
import script from "./LabeldeurPage.vue?vue&type=script&lang=js"
export * from "./LabeldeurPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports